import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=3042eea7"
var script = {}
import style0 from "./tickets.vue?vue&type=style&index=0&id=3042eea7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports